import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { Sidebar } from './components/layout/Sidebar';
import { Header } from './components/layout/Header';
import { Dashboard } from './pages/Dashboard';
import { Settings } from './pages/Settings';
import { HowItWorks } from './pages/HowItWorks';
import { FAQ } from './pages/FAQ';
import { PlaceholderPage } from './pages/PlaceholderPage';
import '@questlabs/react-sdk/dist/style.css';

function App() {
  return (
    <HashRouter>
      <div className="min-h-screen bg-chefBlack text-receiptWhite font-sans flex overflow-x-hidden">
        <Sidebar />
        <div className="flex-1 flex flex-col min-h-screen transition-all duration-300 md:ml-64 ml-16">
          <Header />
          <main className="flex-1 overflow-x-hidden overflow-y-auto bg-chefBlack">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/prep" element={<PlaceholderPage title="Prep Lanes" />} />
              <Route path="/staff" element={<PlaceholderPage title="Staff Schedule" />} />
              <Route path="/feedback" element={<PlaceholderPage title="Guest Feedback" />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/settings" element={<Settings />} />
            </Routes>
          </main>
          <footer className="py-6 text-center border-t border-chefPanel bg-chefDark mt-auto px-4">
            <p className="text-xs font-mono text-receiptMuted">
              Made by LingLink AI and DigLab AI
            </p>
          </footer>
        </div>
      </div>
    </HashRouter>
  );
}

export default App;